
import Vue from 'vue';
export default Vue.extend({
  props: {
    dataProps: {
      type: Object,
      default() {
        return {
          tile_1: {
            headline: null,
            content: null,
            button: null,
            href: null,
          },
          tile_2: {
            headline: null,
            content: null,
            button: null,
          },
        };
      },
    },
  },
  data() {
    return {
      weight: null as number | null,
      height: null as number | null,
      success: null as boolean | null,
    };
  },
  watch: {
    weight(value) {
      this.weight = typeof value === 'number' ? value : null;
    },
    height(value) {
      this.height = typeof value === 'number' ? value : null;
    },
  },
  methods: {
    bmi() {
      if (this.weight === null || this.height === null) {
        return false;
      }
      const bmi = this.weight / Math.pow(this.height / 100, 2);
      this.success = bmi >= 18.5 && bmi <= 30;
    },
  },
});
